import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AuthLoginScreen from "../../features/auth/ui/AuthLoginScreen";
import GuestLayout from "../../widgets/guest-layout";
import { UserData } from "../../features/auth/model/types";
import AuthenticatedRootCustomerPortalApp from "./AuthenticatedRootCustomerPortalApp";
import AppointmentReportUnexpectedFindingsConfirmationScreen from "../../features/report/ui/AppointmentReportUnexpectedFindingsConfirmationScreen";

const CustomerPortalAppRoot = ({ userData }: { userData: UserData | null }) => {
  if (!userData) {
    return (
      <Routes>
        <Route
          path="/"
          element={
            <GuestLayout>
              <AuthLoginScreen />
            </GuestLayout>
          }
        />
        <Route
          path="/confirmation/:confirmationToken"
          element={<AppointmentReportUnexpectedFindingsConfirmationScreen />}
        />
        <Route path="*" element={<Navigate replace to="/" />} />
      </Routes>
    );
  }

  return <AuthenticatedRootCustomerPortalApp />;
};

export default CustomerPortalAppRoot;
